import axios from 'axios';
import { SIGNAL_ABORTED_CODE } from 'core/constants/shopping-cart.constants';
import { shoppingCartService } from 'core/services/shopping-cart/shopping-cart.service';
import type { TSliceExtraReducer } from 'core/store';
import { getCustomerIdFromCheckout } from 'core/store/checkout/checkout-state.utils';
import { createAppAsyncThunk } from 'core/store/store.utils';
import { getCustomerIdByProductSource } from '../cart-state.utils';
import { SLICE_NAMESPACE } from '../constants';
import { ICartState, IChangeProductActionParams } from '../types';

export const changeProductAction = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/changeProductAction`,
  async (payload: IChangeProductActionParams, { getState, rejectWithValue, signal }) => {
    const { checkout, auth } = getState();
    const checkoutCustomerId = getCustomerIdFromCheckout(checkout);
    const customerIdByProductSource = getCustomerIdByProductSource(auth.customer, payload.product.sourceId);
    const customerId = customerIdByProductSource || checkoutCustomerId;

    const abortController = new AbortController();
    signal.addEventListener('abort', () => {
      abortController.abort();
    });

    try {
      await shoppingCartService.putShoppingCart(payload, customerId, abortController.signal);
    } catch (error) {
      if (signal.aborted) return rejectWithValue({ code: SIGNAL_ABORTED_CODE, message: 'Petición cancelada' });
      if (!axios.isAxiosError(error)) {
        throw error;
      }
    }
  },
);

export const changeProductReducer: TSliceExtraReducer<ICartState> = builder => {
  builder
    .addCase(changeProductAction.pending, (state, { meta }) => {
      state.productsLoading = [...state.productsLoading, meta.arg.sku];
      state.success = false;
    })
    .addCase(changeProductAction.fulfilled, (state, { meta }) => {
      state.productsLoading = state.productsLoading.filter(pc => pc !== meta.arg.sku);
      state.success = true;
    })
    .addCase(changeProductAction.rejected, (state, { payload, meta }) => {
      if (payload?.code === SIGNAL_ABORTED_CODE) {
        state.success = false;
        state.productsLoading = state.productsLoading.filter(pc => pc !== meta.arg.sku);
      }
    });

  return builder;
};
